import LoginForm from '../components/loginform/logincomponent';

export default function LoginPage(setIsLoggedIn) {
  return <LoginForm setIsLoggedIn={setIsLoggedIn} />;
}
